import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SetShippingAddressFormv2 from './SetShippingAddressFormv2';
import { RenderSubmitButton } from '../../common/form';
import { showModal, hideModal } from '../../../actions/ModalActions';
import { updateRegistryPublish } from '../../../actions/RegistryActions';

function ShippingAddressSubmitButton({ valid, pristine, submitting, value }) {
  return (
    <div className="wrapping-button-container product-actions">
      <RenderSubmitButton
        pristine={pristine}
        disabled={submitting}
        valid={valid || true}
        className="btn btn-wide"
        value={value}
      />
    </div>
  );
}

ShippingAddressSubmitButton.propTypes = {
  valid: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  value: PropTypes.string,
};

function SetShippingAddressModal(props) {
  const { closeModal, onRegistryPublish } = props;

  function handleRegistryPublish() {
    onRegistryPublish();
  }

  function handleCancel() {
    closeModal();
  }

  return (
    <div id="hide-pages-modalv2">
      <div id="publish-resgistry-modal">
        <div id="registry-visibility" className="registry-visibility">
          <div>
            <div className="modal-header">
              <h1 className="align-left shipping-header">
                Add a Shipping Address Before You Make Your Registry Visible
              </h1>
            </div>
            <div className="modal-body">
              <div className="shipping-form-container">
                <SetShippingAddressFormv2
                  onSuccess={handleRegistryPublish}
                  submitButtonText="Make Registry Visible"
                  secondaryButtonText="Cancel"
                  secondaryButtonAction={handleCancel}
                  secondaryButtonClassName="skip-publish-registry"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SetShippingAddressModal.propTypes = {
  onRegistryPublish: PropTypes.func,
  closeModal: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  onSetShippingAddressSuccess: () =>
    dispatch(updateRegistryPublish(true)).then(() => dispatch(showModal('PUBLISH_REGISTRY'))),
  onRegistryPublish: () =>
    dispatch(updateRegistryPublish(true)).then(() =>
      dispatch(showModal('PUBLISH_REGISTRY', {}, { size: 'md' }))
    ),
  closeModal: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(SetShippingAddressModal);



// WEBPACK FOOTER //
// ./src/components/manage/common/SetShippingAddressModal.jsx